// src/analytics/useAnalyticsContext.js
// Hook to extract analytics context data from AuthContext

import { useAuth } from '../context/AuthContext';

/**
 * Hook to get analytics context data (commerceId, branchId, channel)
 * Extracts data from AuthContext for use in analytics events
 * @returns {Object} Analytics context data
 */
export function useAnalyticsContext() {
  const { channelId, branchId, commerceName } = useAuth();

  return {
    commerceId: channelId || null,
    branchId: branchId || null,
    channel: channelId || null, // Using channelId as channel identifier
    commerceName: commerceName || null
  };
}

